import React from 'react';
import './teaserPopup.css';
import { Label } from '@nooz-optics/nooz-components-lib';
import { Image } from '../../../UI/Media';

export const TeaserPopup = ({ label, color, textColor, image, body }) => (
  <div
    style={{ background: color ? color?.hex : 'white' }}
    className={`teaser-popup relative ${
      textColor ? `text-${textColor?.classname}` : ''
    } flex w-full p-5 `}>
    <div className='flex flex-col items-start pr-10 text-left'>
      <Label
        {...label}
        size='lg'
        weight='medium'
      />
      <Label
        {...body}
        size='sm'
      />
    </div>
    <div className='w-24' />
    <div className='absolute right-0 top-0 h-full w-24'>
      <Image
        height='100%'
        objectFit='cover'
        {...image}
      />
    </div>
  </div>
);
